import { Component, Input } from '@angular/core';
import { TimelineEventoDTO } from '../../../types/smartinteg';

@Component({
  selector: 'app-timeline-rastreio',
  template: `
    <p-timeline [value]="eventos" align="alternate" styleClass="customized-timeline">
      <ng-template pTemplate="marker" let-evento>
        <span class="custom-marker shadow-2" [ngStyle]="{'background-color': getCorMarker(evento.evento)}">
          <i [class]="getIconMarker(evento.evento)"></i>
        </span>
      </ng-template>
      <ng-template pTemplate="content" let-evento>
        <p-card [header]="evento.evento" [subheader]="(evento.timestamp | date:'dd/MM/yyyy HH:mm:ss') || ''">
          <p>{{ evento.detalhes }}</p>
        </p-card>
      </ng-template>
    </p-timeline>
  `,
  styles: [`
    .custom-marker {
      display: flex;
      width: 2rem;
      height: 2rem;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      border-radius: 50%;
      z-index: 1;
    }

    ::ng-deep .customized-timeline .p-timeline-event-content,
    ::ng-deep .customized-timeline .p-timeline-event-opposite {
      line-height: 1;
    }

    @media screen and (max-width: 960px) {
      ::ng-deep .customized-timeline .p-timeline-event-opposite {
        flex: 0;
      }

      ::ng-deep .customized-timeline .p-timeline-event-content {
        flex: 1;
      }
    }
  `]
})
export class TimelineRastreioComponent {
  @Input() eventos: TimelineEventoDTO[] = [];

  getCorMarker(evento: string): string {
    const ev = evento.toUpperCase();
    if (ev.includes('RECEBIDO')) return '#3B82F6';
    if (ev.includes('VALIDADO')) return '#10B981';
    if (ev.includes('PROCESSADO')) return '#F59E0B';
    if (ev.includes('CONCLUIDO') || ev.includes('INTEGRADO')) return '#8B5CF6';
    if (ev.includes('ERRO') || ev.includes('FALHA')) return '#EF4444';
    return '#64748B';
  }

  getIconMarker(evento: string): string {
    const ev = evento.toUpperCase();
    if (ev.includes('RECEBIDO')) return 'pi pi-download';
    if (ev.includes('VALIDADO')) return 'pi pi-check';
    if (ev.includes('PROCESSADO')) return 'pi pi-cog';
    if (ev.includes('CONCLUIDO') || ev.includes('INTEGRADO')) return 'pi pi-send';
    if (ev.includes('ERRO') || ev.includes('FALHA')) return 'pi pi-times';
    return 'pi pi-info-circle';
  }
}
